/** @format */

export enum FilterOptionType {
  Checkbox = 'checkbox',
  Radio = 'radio',
  Selector = 'selector',
}
